
const TooltipNotification = ({ isVisible }) => {

  return (
    <div className={`header-toolip notification ${isVisible ? 'visible' : ''}`} >
      <div className="content-toolip_notification">
        <p className="source-16 c-dark bold pt-20">Sin notificaciones</p>
      </div>
    </div>
  )
}

export default TooltipNotification
